<template>
    <el-menu router>
        <el-menu-item index="/ops/flow" v-if="validPriv('0030001')">数据修正</el-menu-item>
        <el-menu-item index="/ops/import-flow" v-if="validPriv('0030002')">客流数据导入</el-menu-item>
        <el-menu-item index="/ops/import-operate" v-if="validPriv('0030003')">运营数据导入</el-menu-item>
    </el-menu>
</template>
<script>
import auth from "../../../scripts/auth";
export default {
    methods: {
        validPriv(code) {
            return auth.validPrivCode(code);
        },
    },
};
</script>
